import OrganizationTransferInvoiceAPI from '@/api/OrganizationTransferInvoiceAPI.js';
import httpClient from '../../api/axios-httpclient';
import commonFunc from '@/common/commonFunction';

export default {
	/**
	 * Lấy danh sách các chi nhánh thiết lập nhận hóa đơn tải về
	 */
	getOrgTransferInvoices: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: OrganizationTransferInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()),
				data: payload
			},
			true
		);
		if (res && res.Data) {
			context.commit('updateOrgTransferInvoices', res.Data);
			return res.Data;
		}
		return res;
	},

	/**
	 * Thông tin chi tiết  chi nhánh thiết lập nhận hóa đơn tải về
	 */
	getOrgTransferInvoice: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: OrganizationTransferInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${payload.OrgReceiveId}`
		});
		if (res && res.Data) {
			context.commit('updateOrgTransferInvoice', res.Data);
		}
	},

	/**
	 * Thêm mới thông tin chi nhánh thiết lập nhận hóa đơn tải về
	 */
	insertOrgTransferInvoice: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: OrganizationTransferInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/insert`,
			data: payload
		});
		return res;
	},

	/**
	 * Cập nhật thông tin chi nhánh thiết lập nhận hóa đơn tải về
	 */
	updateOrgTransferInvoice: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: OrganizationTransferInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/update`,
			data: payload
		});
		return res;
	},

	/**
	 * Xóa thông tin chi nhánh thiết lập nhận hóa đơn tải về
	 */
	deleteOrgTransferInvoice: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: OrganizationTransferInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/delete`,
			data: payload
		});
		return res;
	},

	getTotalPageAsync: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: OrganizationTransferInvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/total`,
			data: payload
		});

		if (res && res.Success) {
			context.commit('updateTotalPage', res.Data);
		}
		return 0;
	}
};
